// * import third party
import { Alert, AlertDescription, AlertIcon, Box } from '@chakra-ui/react';

// * import local
import { useApp } from '@pages/UploadMappingV2/context/AppContext';
import { tableData, tableHeadLists, tableHeadListsAddProduct } from './const';
import { useBundleStore } from '@pages/UploadMappingV2/hooks/state/useAddProductBundle';
import { useConfirmModal } from '@store/useConfirmModal';
import ModalConfirmTemplate from '@pages/UploadMappingV2/components/ui/ModalConfirmTemplate';
import TableTemplate from '@pages/UploadMappingV2/components/Table/TableTemplate';
import TableAddProduct from '@pages/UploadMappingV2/components/Table/TableAddProduct';

export default function ModalAddProductBundle() {
    const { set } = useConfirmModal();
    const { isOpenModalAddProductBundle, onCloseModalAddProductBundle, onOpenModalConfirmAddProductBundle } = useApp();

    const {
        validateBundle,
        saveBundle,
        saveDirectBundle,
        resetBundle,
        hasUnsavedChanges,
        updateBundle,
        isEditing,
        isDirectEditing,
    } = useBundleStore();

    const handleCancel = () => {
        if (isEditing || isDirectEditing) return handleCloseModal();

        if (hasUnsavedChanges()) {
            return set({
                isOpen: true,
                title: 'Batal menambahkan produk?',
                desc: 'Data yang telah dituliskan akan hilang, perlu melakukan pengisian ulang untuk menambahkan atau menghubungkan produk.',
                btnLabelYes: 'Ya, batal',
                btnLabelNo: 'Kembali',
                onSubmit: () => {
                    handleCloseModal();
                },
            });
        }

        handleCloseModal();
    };

    const handleSubmitBundle = () => {
        validateBundle();
        const { errors } = useBundleStore.getState();
        if (Object.keys(errors).length) return;

        if (isDirectEditing) {
            saveDirectBundle();
            onOpenModalConfirmAddProductBundle();
        } else {
            isEditing ? updateBundle() : saveBundle();
        }

        handleCloseModal();
    };

    const handleCloseModal = () => {
        onCloseModalAddProductBundle();
        resetBundle();
    };

    return (
        <ModalConfirmTemplate
            isOpen={isOpenModalAddProductBundle}
            onClose={handleCancel}
            width="1000px"
            onSubmit={handleSubmitBundle}
        >
            <Box p={'8px'} />
            <TableTemplate tableHeadLists={tableHeadLists} tableData={tableData} />

            <Box mx={'5%'} mt={'12px'} mb={'24px'}>
                <Alert status="info" variant={'border'} alignItems={'start'} mb={'12px'}>
                    <AlertIcon color={'paragon.500'} />
                    <AlertDescription>
                        Untuk bundle yang memiliki produk serupa sejumlah 2 pcs atau lebih, mohon dituliskan semuanya.
                        Contoh: Promo beli 2 Wardah Lipstick Sugary Pink, gratis 1 Wardah Lipstick Sugary Pink. Maka
                        pada baris 1, 2, dan 3 dituliskan ‘Wardah Lipstick Sugary Pink’.
                    </AlertDescription>
                </Alert>

                <TableAddProduct tableHeadLists={tableHeadListsAddProduct} />
            </Box>
        </ModalConfirmTemplate>
    );
}
